(() => {
  const ROOT_SELECTOR = '[data-heathen-sell-with-us]';
  const FAQ_ICON_DOWN =
    '<path d="M22 13.8008L16 19.8008L10 13.8008L11.4 12.4008L16 17.0008L20.6 12.4008L22 13.8008Z" fill="#403F42"/>';
  const FAQ_ICON_UP =
    '<path d="M10 18.1992L16 12.1992L22 18.1992L20.6 19.5992L16 14.9992L11.4 19.5992L10 18.1992Z" fill="#403F42"/>';
  const FAQ_ANIMATION_MS = 300;

  function slideDown(element, duration = FAQ_ANIMATION_MS) {
    return new Promise((resolve) => {
      let finished = false;
      const done = () => {
        if (finished) return;
        finished = true;
        element.removeEventListener('transitionend', onTransitionEnd);
        element.style.height = '';
        element.style.overflow = '';
        element.style.transition = '';
        resolve();
      };
      const onTransitionEnd = (event) => {
        if (event.target === element && event.propertyName === 'height') done();
      };

      element.classList.add('open');
      element.style.display = 'block';
      element.style.overflow = 'hidden';
      const targetHeight = element.scrollHeight;
      element.style.height = '0px';

      requestAnimationFrame(() => {
        element.style.transition = `height ${duration}ms ease`;
        element.style.height = `${targetHeight}px`;
      });

      element.addEventListener('transitionend', onTransitionEnd);
      window.setTimeout(done, duration + 50);
    });
  }

  function slideUp(element, duration = FAQ_ANIMATION_MS) {
    return new Promise((resolve) => {
      let finished = false;
      const done = () => {
        if (finished) return;
        finished = true;
        element.removeEventListener('transitionend', onTransitionEnd);
        element.classList.remove('open');
        element.style.display = 'none';
        element.style.height = '';
        element.style.overflow = '';
        element.style.transition = '';
        resolve();
      };
      const onTransitionEnd = (event) => {
        if (event.target === element && event.propertyName === 'height') done();
      };

      element.style.height = `${element.scrollHeight}px`;
      element.style.overflow = 'hidden';

      requestAnimationFrame(() => {
        element.style.transition = `height ${duration}ms ease`;
        element.style.height = '0px';
      });

      element.addEventListener('transitionend', onTransitionEnd);
      window.setTimeout(done, duration + 50);
    });
  }

  function qs(root, selector) {
    return root.querySelector(selector);
  }

  function qsa(root, selector) {
    return Array.from(root.querySelectorAll(selector));
  }

  function getHeaderHeight() {
    const header = document.querySelector('.section-header, .custom-header, sticky-header');
    return header ? header.offsetHeight : 0;
  }

  function getNavHeight(root) {
    const nav = qs(root, '.nav-tabs-container');
    return nav ? nav.offsetHeight : 0;
  }

  function cleanHash(hash) {
    return hash.replace(/^\#/, '').replace(/\/$/, '').replace(/[^a-zA-Z0-9-_]/g, '');
  }

  function activateCalculatorTab(root, tabName) {
    qsa(root, '.calculator-tabs .tab').forEach((tab) => {
      tab.classList.toggle('active', tab.dataset.tab === tabName);
    });
    qsa(root, '.calculator-content').forEach((panel) => {
      panel.classList.remove('active');
    });
    const panel = qs(root, `#${tabName}-tab`);
    if (panel) panel.classList.add('active');
  }

  function setActiveNavTab(root, targetId) {
    let tabId = targetId;
    const target = document.getElementById(targetId);
    if (!target) return;

    if (target.closest('#kalkulator')) {
      tabId = 'kalkulator';
      if (targetId === 'tabela-stawek') {
        activateCalculatorTab(root, 'table');
      } else if (targetId === 'kalkulator') {
        activateCalculatorTab(root, 'calculator');
      }
    } else if (target.closest('#jak-zaczac')) {
      tabId = 'jak-zaczac';
    } else if (target.closest('#produkty')) {
      tabId = 'produkty';
    } else if (target.closest('#wartosci')) {
      tabId = 'wartosci';
    } else if (target.closest('#faq')) {
      tabId = 'faq';
    } else if (target.closest('#archiwum')) {
      tabId = 'archiwum';
    }

    qsa(root, '.nav-tab').forEach((link) => {
      link.classList.toggle('active', link.getAttribute('href') === `#${tabId}`);
    });
  }

  function scrollToSection(root, targetId) {
    const target = document.getElementById(targetId);
    if (!target) return;

    const runScroll = () => {
      const offset =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        getNavHeight(root) -
        getHeaderHeight() -
        20;

      if (offset < 0) return;

      window.scrollTo({ top: offset, behavior: 'smooth' });
      setActiveNavTab(root, targetId);
    };

    window.setTimeout(runScroll, 100);
    window.setTimeout(runScroll, 500);
  }

  function handleInitialHash(root) {
    if (!window.location.hash) return;
    const clean = cleanHash(window.location.hash);
    if (!clean) return;

    if (clean === 'tabela-stawek') {
      qsa(root, '.nav-tab').forEach((link) => {
        link.classList.toggle('active', link.getAttribute('href') === '#kalkulator');
      });
      window.setTimeout(() => {
        activateCalculatorTab(root, 'table');
        window.setTimeout(() => scrollToSection(root, clean), 100);
      }, 200);
      return;
    }

    if (clean === 'kalkulator') {
      qsa(root, '.nav-tab').forEach((link) => {
        link.classList.toggle('active', link.getAttribute('href') === '#kalkulator');
      });
      window.setTimeout(() => {
        activateCalculatorTab(root, 'calculator');
        window.setTimeout(() => scrollToSection(root, clean), 100);
      }, 200);
      return;
    }

    scrollToSection(root, clean);
  }

  function calculateProgressiveCommission(tierIdentifier, price) {
    const value = Number.parseFloat(price) || 0;
    if (value <= 0) {
      return { commission: 0, averageRate: 0 };
    }

    const tier =
      tierIdentifier === 'the_circle' || tierIdentifier === 'circle'
        ? 'The Circle'
        : tierIdentifier === 'devoted'
          ? 'Devoted'
          : 'Member';

    let totalCommission = 0;

    if (tier === 'Member') {
      if (value <= 500) totalCommission = value * 0.35;
      else if (value <= 1000) totalCommission = 500 * 0.35 + (value - 500) * 0.325;
      else if (value <= 2500)
        totalCommission = 500 * 0.35 + (1000 - 500) * 0.325 + (value - 1000) * 0.3;
      else if (value <= 5500)
        totalCommission =
          500 * 0.35 + (1000 - 500) * 0.325 + (2500 - 1000) * 0.3 + (value - 2500) * 0.28;
      else if (value <= 12500)
        totalCommission =
          500 * 0.35 +
          (1000 - 500) * 0.325 +
          (2500 - 1000) * 0.3 +
          (5500 - 2500) * 0.28 +
          (value - 5500) * 0.27;
      else if (value <= 25000)
        totalCommission =
          500 * 0.35 +
          (1000 - 500) * 0.325 +
          (2500 - 1000) * 0.3 +
          (5500 - 2500) * 0.28 +
          (12500 - 5500) * 0.27 +
          (value - 12500) * 0.26;
      else
        totalCommission =
          500 * 0.35 +
          (1000 - 500) * 0.325 +
          (2500 - 1000) * 0.3 +
          (5500 - 2500) * 0.28 +
          (12500 - 5500) * 0.27 +
          (25000 - 12500) * 0.26 +
          (value - 25000) * 0.25;
    } else if (tier === 'Devoted') {
      if (value <= 500) totalCommission = value * 0.335;
      else if (value <= 1000) totalCommission = 500 * 0.335 + (value - 500) * 0.31;
      else if (value <= 2500)
        totalCommission = 500 * 0.335 + (1000 - 500) * 0.31 + (value - 1000) * 0.285;
      else if (value <= 5500)
        totalCommission =
          500 * 0.335 + (1000 - 500) * 0.31 + (2500 - 1000) * 0.285 + (value - 2500) * 0.265;
      else if (value <= 12500)
        totalCommission =
          500 * 0.335 +
          (1000 - 500) * 0.31 +
          (2500 - 1000) * 0.285 +
          (5500 - 2500) * 0.265 +
          (value - 5500) * 0.255;
      else if (value <= 25000)
        totalCommission =
          500 * 0.335 +
          (1000 - 500) * 0.31 +
          (2500 - 1000) * 0.285 +
          (5500 - 2500) * 0.265 +
          (12500 - 5500) * 0.255 +
          (value - 12500) * 0.245;
      else
        totalCommission =
          500 * 0.335 +
          (1000 - 500) * 0.31 +
          (2500 - 1000) * 0.285 +
          (5500 - 2500) * 0.265 +
          (12500 - 5500) * 0.255 +
          (25000 - 12500) * 0.245 +
          (value - 25000) * 0.235;
    } else if (tier === 'The Circle') {
      if (value <= 500) totalCommission = value * 0.31;
      else if (value <= 1000) totalCommission = 500 * 0.31 + (value - 500) * 0.285;
      else if (value <= 2500)
        totalCommission = 500 * 0.31 + (1000 - 500) * 0.285 + (value - 1000) * 0.26;
      else if (value <= 5500) {
        totalCommission =
          500 * 0.31 + (1000 - 500) * 0.285 + (2500 - 1000) * 0.26 + (value - 2500) * 0.24;
      } else if (value <= 12500)
        totalCommission =
          500 * 0.31 +
          (1000 - 500) * 0.285 +
          (2500 - 1000) * 0.26 +
          (5500 - 2500) * 0.24 +
          (value - 5500) * 0.23;
      else if (value <= 25000)
        totalCommission =
          500 * 0.31 +
          (1000 - 500) * 0.285 +
          (2500 - 1000) * 0.26 +
          (5500 - 2500) * 0.24 +
          (12500 - 5500) * 0.23 +
          (value - 12500) * 0.22;
      else
        totalCommission =
          500 * 0.31 +
          (1000 - 500) * 0.285 +
          (2500 - 1000) * 0.26 +
          (5500 - 2500) * 0.24 +
          (12500 - 5500) * 0.23 +
          (25000 - 12500) * 0.22 +
          (value - 25000) * 0.21;
    } else {
      totalCommission = value * 0.25;
    }

    return {
      commission: totalCommission,
      averageRate: value > 0 ? (totalCommission / value) * 100 : 0,
    };
  }

  function updateRangeBackground(root) {
    const slider = qs(root, '#price-slider');
    const fill = qs(root, '#slider-fill');
    if (!slider || !fill) return;

    const min = Number.parseFloat(slider.min) || 0;
    const max = Number.parseFloat(slider.max) || 150000;
    const value = Number.parseFloat(slider.value) || 0;
    const percentage = ((value - min) / (max - min)) * 100;
    const validPercentage = Math.max(0, Math.min(100, percentage));
    fill.style.width = `${validPercentage}%`;
  }

  function updateCalculation(root) {
    const priceInput = qs(root, '#price-input');
    const membership = qs(root, 'input[name="membership"]:checked');
    const commissionRateEl = qs(root, '#commission-rate');
    const commissionAmountEl = qs(root, '#commission-amount');
    const earningsEl = qs(root, '#earnings');

    if (!priceInput || !commissionRateEl || !commissionAmountEl || !earningsEl) return;

    const price = Number.parseFloat(priceInput.value);
    if (!price || Number.isNaN(price) || price <= 0) {
      commissionRateEl.textContent = '0%';
      commissionAmountEl.textContent = '0 pln';
      earningsEl.textContent = '0 pln';
      return;
    }

    const membershipValue = membership ? membership.value : 'member';
    let tierIdentifier = 'member';
    if (membershipValue === 'circle' || membershipValue === 'the_circle') {
      tierIdentifier = 'the_circle';
    } else if (membershipValue === 'devoted') {
      tierIdentifier = 'devoted';
    }

    const result = calculateProgressiveCommission(tierIdentifier, price);
    const commissionAmount = Math.ceil(result.commission);
    const earnings = Math.floor(price - commissionAmount);
    const effectiveRate = price > 0 ? (commissionAmount / price) * 100 : 0;
    const roundedRate = Math.ceil(effectiveRate * 100) / 100;

    commissionRateEl.textContent = `${roundedRate.toFixed(2).replace('.', ',')}%`;
    commissionAmountEl.textContent = `${new Intl.NumberFormat('pl-PL', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(commissionAmount)} pln`;
    earningsEl.textContent = `${new Intl.NumberFormat('pl-PL', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(earnings)} pln`;
  }

  function bindArchiveSlider(root) {
    const archive = qs(root, '#archiwum');
    if (!archive) return;

    const slider = qs(archive, '.product-slider');
    const prev = qs(archive, '.brand-prev');
    const next = qs(archive, '.brand-next');
    if (!slider) return;

    const getStep = () => {
      const first = slider.querySelector('a');
      if (!first) return 360;
      const style = window.getComputedStyle(slider);
      const gap = Number.parseFloat(style.gap || style.columnGap || '8') || 8;
      return Math.round(first.getBoundingClientRect().width + gap);
    };

    const updateArrows = () => {
      if (!prev || !next) return;
      const max = Math.max(0, slider.scrollWidth - slider.clientWidth - 2);
      const atStart = slider.scrollLeft <= 2;
      const atEnd = slider.scrollLeft >= max;
      prev.classList.toggle('slick-disabled', atStart);
      next.classList.toggle('slick-disabled', atEnd);
      prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    };

    if (prev) {
      prev.addEventListener('click', () => {
        if (prev.classList.contains('slick-disabled')) return;
        slider.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', () => {
        if (next.classList.contains('slick-disabled')) return;
        slider.scrollBy({ left: getStep(), behavior: 'smooth' });
      });
    }

    slider.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  function getStickyNavTop() {
    return getHeaderHeight() + 12;
  }

  function bindStickyNavTabs(root) {
    const navTabs = qs(root, '.nav-tabs-container');
    if (!navTabs) return;

    let stickyObserver = null;

    const mountObserver = () => {
      if (stickyObserver) {
        stickyObserver.disconnect();
      }

      const stickyTop = getStickyNavTop();
      stickyObserver = new IntersectionObserver(
        ([entry]) => {
          navTabs.classList.toggle('is-sticky', entry.intersectionRatio < 1);
        },
        {
          threshold: [1],
          rootMargin: `-${stickyTop}px 0px 0px 0px`,
        }
      );

      stickyObserver.observe(navTabs);
    };

    mountObserver();
    window.addEventListener('resize', mountObserver);
  }

  function initSellWithUs(root) {
    if (!root || root.dataset.heathenSellBound === '1') return;
    root.dataset.heathenSellBound = '1';

    bindStickyNavTabs(root);

    qsa(root, '.nav-tab').forEach((link) => {
      link.addEventListener('click', (event) => {
        const href = link.getAttribute('href');
        if (!href || !href.startsWith('#')) return;
        event.preventDefault();
        const targetId = cleanHash(href);
        if (!targetId || !document.getElementById(targetId)) return;
        qsa(root, '.nav-tab').forEach((item) => item.classList.remove('active'));
        link.classList.add('active');
        scrollToSection(root, targetId);
      });
    });

    window.addEventListener('hashchange', () => {
      const targetId = cleanHash(window.location.hash);
      if (targetId) scrollToSection(root, targetId);
    });

    let scrollTicking = false;
    window.addEventListener('scroll', () => {
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(() => {
        scrollTicking = false;
        const scrollPosition = window.scrollY + getNavHeight(root) + 50;
        const sections = ['jak-zaczac', 'produkty', 'wartosci', 'kalkulator', 'faq', 'archiwum']
          .map((id) => document.getElementById(id))
          .filter(Boolean);

        sections.forEach((section) => {
          const sectionTop = section.offsetTop;
          const sectionHeight = section.offsetHeight;
          if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
            qsa(root, '.nav-tab').forEach((link) => {
              link.classList.toggle('active', link.getAttribute('href') === `#${section.id}`);
            });
          }
        });
      });
    });

    qsa(root, '.faq-question').forEach((question) => {
      question.addEventListener('click', async (event) => {
        event.preventDefault();
        const answer = question.nextElementSibling;
        const icon = question.querySelector('.icon svg');
        if (!answer || !icon || answer.dataset.faqAnimating === 'true') return;

        const isOpen = answer.classList.contains('open');
        answer.dataset.faqAnimating = 'true';

        try {
          if (isOpen) {
            await slideUp(answer);
            icon.innerHTML = FAQ_ICON_DOWN;
          } else {
            await slideDown(answer);
            icon.innerHTML = FAQ_ICON_UP;
          }
        } finally {
          delete answer.dataset.faqAnimating;
        }
      });
    });

    qsa(root, '.calculator-tabs .tab').forEach((tab) => {
      tab.addEventListener('click', () => {
        activateCalculatorTab(root, tab.dataset.tab);
      });
    });

    const priceInput = qs(root, '#price-input');
    const priceSlider = qs(root, '#price-slider');

    if (priceInput) {
      priceInput.addEventListener('input', () => {
        if (priceSlider) priceSlider.value = priceInput.value;
        updateRangeBackground(root);
        updateCalculation(root);
      });
    }

    if (priceSlider) {
      priceSlider.addEventListener('input', () => {
        if (priceInput) priceInput.value = priceSlider.value;
        updateRangeBackground(root);
        updateCalculation(root);
      });
    }

    qsa(root, 'input[name="membership"]').forEach((input) => {
      input.addEventListener('change', () => updateCalculation(root));
    });

    qsa(root, 'input[name="membership-table"]').forEach((input) => {
      input.addEventListener('change', () => {
        const selectedTier = input.value;
        qsa(root, '.tier-rates').forEach((tierRates) => {
          tierRates.classList.remove('active');
          tierRates.style.display = 'none';
        });
        const activeTier = qs(root, `#${selectedTier}-table-rates`);
        if (activeTier) {
          activeTier.classList.add('active');
          activeTier.style.display = 'block';
        }
      });
    });

    const defaultTier = root.dataset.customerMembershipTier || 'member';
    const applyDefaultMembershipTier = (tier) => {
      const normalized = tier === 'circle' ? 'circle' : tier === 'devoted' ? 'devoted' : 'member';
      const calculatorInput = qs(root, `input[name="membership"][value="${normalized}"]`);
      const tableInput = qs(root, `input[name="membership-table"][value="${normalized}"]`);
      if (calculatorInput) calculatorInput.checked = true;
      if (tableInput) {
        tableInput.checked = true;
        qsa(root, '.tier-rates').forEach((tierRates) => {
          tierRates.classList.remove('active');
          tierRates.style.display = 'none';
        });
        const activeTier = qs(root, `#${normalized}-table-rates`);
        if (activeTier) {
          activeTier.classList.add('active');
          activeTier.style.display = 'block';
        }
      }
    };

    if (root.dataset.customerMembershipTier) {
      applyDefaultMembershipTier(defaultTier);
    } else {
      qsa(root, '.tier-rates').forEach((tierRates) => {
        tierRates.style.display = tierRates.classList.contains('active') ? 'block' : 'none';
      });
    }

    updateRangeBackground(root);
    updateCalculation(root);
    bindArchiveSlider(root);

    handleInitialHash(root);
    window.setTimeout(() => handleInitialHash(root), 300);
    window.setTimeout(() => handleInitialHash(root), 800);
    window.addEventListener('load', () => {
      window.setTimeout(() => handleInitialHash(root), 100);
      window.setTimeout(() => handleInitialHash(root), 500);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initSellWithUs);
  });

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll(ROOT_SELECTOR).forEach(initSellWithUs);
  });
})();
